import React from "react";

const About = () => {
  return (
    <section
      id="about"
      className="layout-container py-24 md:py-32 border-t border-borderSubtle scroll-fade"
    >
      {/* Section Header */}
      <div className="flex flex-col">
        <span className="text-xs font-mono tracking-widest text-accent uppercase font-medium">
          <p>/ 01 / ABOUT</p>
        </span>
        <h2 className="text-xl font-normal text-white mt-2">
          Brief & Background
        </h2>
      </div>

      {/* Two-Column Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 mt-12">
        {/* Left Column: Short bio */}
        <div className="flex flex-col gap-6 text-zinc-400 text-base md:text-lg leading-relaxed">
          <p>
            I am working as a Software Engineer – Integrations at FreJun India,
            where my daily focus is engineering AI-powered integrations and
            developer-facing SDKs.
          </p>
          <p>
            Computer Science Engineering student at Chandigarh University
            (2022–2026).
          </p>
        </div>

        {/* Right Column: Stat cards (Whitespace only) */}
        <div className="grid grid-cols-2 gap-y-12 gap-x-8">
          {/* Stat 1 */}
          <div className="flex flex-col gap-1">
            <span className="text-4xl font-normal text-white">~1</span>
            <span className="text-xs text-zinc-500 font-medium uppercase tracking-widest">
              Yr Experience
            </span>
          </div>

          {/* Stat 2 */}
          <div className="flex flex-col gap-1">
            <span className="text-4xl font-normal text-white">Sept, 2025</span>
            <span className="text-xs text-zinc-500 font-medium uppercase tracking-widest">
              India
            </span>
          </div>

          {/* Stat 3 */}
          <div className="flex flex-col gap-1">
            <span className="text-4xl font-normal text-white">2026</span>
            <span className="text-xs text-zinc-500 font-medium uppercase tracking-widest">
              Graduation Year
            </span>
          </div>

          {/* Stat 4 */}
          <div className="flex flex-col gap-1">
            <span className="text-4xl font-normal text-white">8.12</span>
            <span className="text-xs text-zinc-500 font-medium uppercase tracking-widest">
              B.E. CSE CGPA
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
